/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserUsDto } from '../../models/user-us-dto';

export interface GetDashboardManagementUsers$Params {
  orid?: number;
}

export function getDashboardManagementUsers(http: HttpClient, rootUrl: string, params?: GetDashboardManagementUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserUsDto>>> {
  const rb = new RequestBuilder(rootUrl, getDashboardManagementUsers.PATH, 'get');
  if (params) {
    rb.query('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserUsDto>>;
    })
  );
}

getDashboardManagementUsers.PATH = '/api/DashboardManagement/getDashboardManagementUsers';
